import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  isRepairFromModel,
  validateIsRepairCondition,
  type IsRepairState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const IS_REPAIR = (
  Details: React.ComponentType<ConditionTypeDetailsProps<IsRepairState>>,
): ConditionType<IsRepairState, Condition.IsRepair> => ({
  name: CONDITION_NAMES[Condition.IS_REPAIR],
  description(state) {
    return t("Return is for a repair");
  },
  Details(props: ConditionTypeDetailsProps<IsRepairState>) {
    return React.createElement(Details, props);
  },
  empty: false,
  fromModel(model) {
    return isRepairFromModel(model);
  },
  toModel(state) {
    return { type: Condition.IS_REPAIR };
  },
  valid(state) {
    return validateIsRepairCondition(state).valid;
  },
});
